
import {NgModule} from '@angular/core';
import {CookieComponent} from './cookie/cookie.component';
import {CookieLawModule} from 'angular2-cookie-law';


@NgModule({
  imports: [
    CookieLawModule,
  ],
  exports: [
    CookieComponent,
  ],
  declarations: [
    CookieComponent,
  ],
})

export class CookieModule {

}



// WEBPACK FOOTER //
// ./src/app/cookie/cookie.module.ts